import React from "react";
import { Skeleton } from "@progress/kendo-react-indicators";
import "./CommentsTableNew.scss";

export default function CommentsTableSkeleton() {
    return (
        <>
            {Array.from({ length: 4 }).map((_, idx) =>
                <tr>
                    <td className="left-aligned comment-comment-column comment-hover">
                        <Skeleton shape={'text'} style={{ width: '80%' }} />
                    </td>
                    <td className="left-aligned user-comment-column">
                        <Skeleton shape={'text'} style={{ width: '80%' }} />
                    </td>
                    <td className="left-aligned comment-text-style date-comment-column">
                        <Skeleton shape={'text'} style={{ width: '80%' }} />
                    </td>
                    <td className="left-aligned action-comment-column">
                        <Skeleton shape={'text'} style={{ width: '80%' }} />
                    </td>
                    <td className="center-aligned comment-action-column attachment-comment-column">
                        <Skeleton shape={'text'} style={{ width: '80%' }} />
                    </td>
                </tr>
            )}
        </>
    );
}